import React, { useEffect, useMemo, useState } from "react";
import Box from "components/common/Box";
import { makeStyles } from "@mui/styles";
import Text from "components/common/Text";
import Grid from "components/common/Grid";
import IconButton from "components/common/IconButton";
import Stack from "components/common/Stack";
import MenuItem from "components/common/MenuItem";
import Paper from "components/common/Paper";
import DatePickerModal from "components/common/DatePickerModal";
import Dialog from "components/common/DialogMD";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import InputBase from "@mui/material/InputBase";
import SearchIcon from "@mui/icons-material/Search";
import InputLabel from "@mui/material/InputLabel";
import EventIcon from "@mui/icons-material/Event";
import InputAdornment from "@mui/material/InputAdornment";
import OutlinedInput from "@mui/material/OutlinedInput";
import FileDownloadIcon from "@mui/icons-material/FileDownload";
import CheckInTable from "./CheckInTable";
import * as XLSX from "xlsx";
import { CheckIncustomerApi } from "stores/CheckIn/CheckInCustomerApi";
const CheckIn = ({
  drawerOpen,
  checinCustome,
  toggleDrawer,
  onChange,
  from_date,
  to_date,
  onDatePickerSub,
  dropdownData,
  formData,
  open,
  onClose,
  onclick,
  handlecheckinsubmit,
  isLoading,
  saveManufacturerId,
  getmodeldate,
  limit,
  page,
  totalItems,
  onPageChange,
  checkInDetailsStatus,
  totalCount,
  searchhandleChange,
  handleReset,
  sorting,
  handleChangeSorting
}) => {
  const [checkinExcelData, setCheckinExcelData] = useState("");
  const stationdropdownItems = useMemo(() => {
    return dropdownData?.chargingStations?.map((ven) => (
      <MenuItem sx={{ fontSize: "14px" }} key={ven.id} value={ven.id}>
        {ven.name}
      </MenuItem>
    ));
  }, [dropdownData]);
  const [custom, setCustom] = useState("");

  const dateType = [
    { value: "Current Month", key: "Current Month" },
    { value: "day", key: "Last 24 Hours" },
    { value: "week", key: "Last Week" },
    { value: "month", key: "Last Month" },
    { value: "year", key: "Last Year" },
    { value: "custom", key: "Custom" },
  ];

  const classes = useStyles();
  const handleManufacturerChange = (event) => {
    const { value } = event.target;

    onChange("manufacturers", value);
    saveManufacturerId(value);
  };
  useEffect(() => {
    const fetchVehicleData = async () => {
      try {
        const limit = totalCount;
        const data = await CheckIncustomerApi.getCheckInBulkExportcustomerData({
          limit,
        });

        setCheckinExcelData(data?.result?.visitDetails);
      } catch (error) {
        console.error("Error exporting Navigation data:", error);
      }
    };

    fetchVehicleData();
  }, [totalCount]);
  const downloadAsExcel = () => {
    const searchHistorydata = checkinExcelData.map((d) => ({
      "Customer Name": d?.customer_name,
      Trip: d?.session_status,
      "Charging Station": d?.charging_station,
      Network: d?.charging_networks,
      Manufacturer: d?.manufacturer_name,
      Model: d?.vehicle_model_name,
      Connector: d?.connectors,
      Variant: d?.vehicle_variant_name,
      Date: d?.date,
      "Charging Time": d?.time,
      // Checkin: d?.check_in,
      "Unit Charged": d?.units_charged,
      Amount: d?.amount,
    }));
    const worksheet = XLSX.utils.json_to_sheet(searchHistorydata);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "navigation Data");
    XLSX.writeFile(workbook, "CustomerData.xlsx");
  };
  return (
    <Grid container>
      <Grid item xs={12} lg={12}>
        <Paper className={classes.checkIn_heading_paper}>
          <Text variant="h5" className={classes.checkIn_text}>
            Check In
          </Text>
          <span
            onClick={() => downloadAsExcel(checinCustome)}
            className={classes.exportfile}
          >
            <FileDownloadIcon className={classes.fileDownload_icon} />
            Export Report
          </span>
          <Grid>
            <Box className={classes.searchBox}>
              <Paper className={classes.searchBox_paper}>
                <IconButton type="submit" sx={{ p: "5px" }} aria-label="search">
                  <SearchIcon />
                </IconButton>
                <InputBase
                  sx={{ ml: 1, flex: 1 }}
                  placeholder="Search"
                  onChange={(e) =>
                    searchhandleChange("inputsearch", e.target.value)
                  }
                  inputProps={{ "aria-label": "search" }}
                />
              </Paper>
            </Box>
          </Grid>
          <Stack
            direction={{ sm: "column", xs: "column", md: "row" }}
            spacing={2}
            className={classes.filter_checkIn_container}
          >
            <Stack
              direction={{ sm: "column", xs: "column", md: "row" }}
              spacing={1}
            >
              <Box sx={{ maxWidth: 143, minWidth: 143 }}>
                <FormControl fullWidth size="small">
                  <InputLabel sx={{ fontSize: "14px" }} id="location-label">
                    Charging Station
                  </InputLabel>
                  <Select
                    sx={{ fontSize: "14px" }}
                    labelId="location-label"
                    label="Charging Station"
                    className={classes.table_location}
                    value={
                      formData.chargingStations
                        ? formData.chargingStations
                        : "All"
                    }
                    onChange={(e) =>
                      onChange("chargingStations", e.target.value)
                    }
                  >
                    <MenuItem sx={{ fontSize: "14px" }} selected value="All">
                      All
                    </MenuItem>
                    {stationdropdownItems}
                    {/* {dropdownData?.chargingStations?.map((ven) => (
                      <MenuItem
                        sx={{ fontSize: "14px" }}
                        key={ven.id}
                        value={ven.id}
                      >
                        {ven.name}
                      </MenuItem>
                    ))} */}
                  </Select>
                </FormControl>
              </Box>

              <Box sx={{ maxWidth: 143, minWidth: 143 }}>
                <FormControl fullWidth size="small">
                  <InputLabel sx={{ fontSize: "14px" }} id="location-label">
                    Manufacturer
                  </InputLabel>
                  <Select
                    sx={{ fontSize: "14px" }}
                    labelId="location-label"
                    label="Manufacture"
                    className={classes.table_location}
                    value={
                      formData.manufacturers ? formData.manufacturers : "All"
                    }
                    // onChange={(e) => onChange("manufacturers", e.target.value)}
                    onChange={handleManufacturerChange}
                  >
                    <MenuItem sx={{ fontSize: "14px" }} selected value="All">
                      All
                    </MenuItem>
                    {dropdownData?.manufacturers?.map((locs) => (
                      <MenuItem
                        sx={{ fontSize: "14px" }}
                        key={locs.id}
                        value={locs.id}
                      >
                        {locs.name}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Box>

              <Box sx={{ maxWidth: 143, minWidth: 143 }}>
                <FormControl fullWidth size="small">
                  <InputLabel sx={{ fontSize: "14px" }} id="manufacturer-label">
                    Model
                  </InputLabel>
                  <Select
                    sx={{ fontSize: "14px" }}
                    labelId="manufacturer-label"
                    label="Model"
                    value={formData.models ? formData.models : "All"}
                    onChange={(e) => onChange("models", e.target.value)}
                  >
                    <MenuItem sx={{ fontSize: "14px" }} value="All">
                      All
                    </MenuItem>
                    {getmodeldate?.map((models) => (
                      <MenuItem
                        sx={{ fontSize: "14px" }}
                        key={models.id}
                        value={models.id}
                      >
                        {models.name}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Box>
              {/* <Box sx={{ maxWidth: 143, minWidth: 143 }}>
                <FormControl fullWidth size="small">
                  <InputLabel sx={{ fontSize: "14px" }} id="model-label">
                    Connector
                  </InputLabel>
                  <Select
                    sx={{ fontSize: "14px" }}
                    labelId="model-label"
                    label="Connector"
                    value={formData.connector ? formData.connector : "All"}
                    onChange={(e) => onChange("connector", e.target.value)}
                  >
                    <MenuItem sx={{ fontSize: "14px" }} value="All">
                      All
                    </MenuItem>
                    {dropdownData?.connectors?.map((connector) => (
                      <MenuItem
                        sx={{ fontSize: "14px" }}
                        key={connector.id}
                        value={connector.id}
                      >
                        {connector.name}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Box> */}
              <Box sx={{ minWidth: 155 }}>
                <FormControl fullWidth size="small">
                  <InputLabel
                    sx={{ fontSize: "15px", color: "#9e9e9e" }}
                    id="demo-simple-select-label"
                  >
                    Select Filter
                  </InputLabel>

                  <Select
                    sx={{ fontSize: "15px" }}
                    labelId="demo-simple-select-label"
                    id="demo-simple-select"
                    label="Select Filter"
                    value={sorting?sorting:"All"}
                    onChange={handleChangeSorting}
                  >
                    {filteroldest.map((option, index) => (
                      <MenuItem key={index} value={option.value}>
                        {option.label}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Box>
              <Box sx={{ maxWidth: 143, minWidth: 143 }}>
                <FormControl fullWidth size="small">
                  <InputLabel sx={{ fontSize: "14px" }} id="model-label">
                    Select Date
                  </InputLabel>
                  <Select
                    sx={{ fontSize: "14px" }}
                    labelId="location-label"
                    label="Select Date"
                    value={custom ? custom : "Current Month"}
                    onChange={(e, value) => {
                      setCustom(e.target.value);
                      onChange(e.target.value);
                    }}
                  >
                    {dateType.map((date) => (
                      <MenuItem
                        sx={{ fontSize: "14px" }}
                        key={date.value}
                        value={date.value}
                      >
                        {date.key}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Box>

              {custom === "custom" ? (
                <Box sx={{ minWidth: 155 }}>
                  <FormControl fullWidth size="small">
                    <InputLabel sx={{ fontSize: "12px" }} id="daterange-label">
                      Date Range
                    </InputLabel>
                    <OutlinedInput
                      label="Date Range"
                      sx={{
                        fontSize: "10px !important",
                        height: "35px !important",
                        fontWeight: "600",
                        backgroundColor: "white",
                      }}
                      id="outlined-adornment-amount"
                      value={
                        from_date && to_date ? `${from_date} - ${to_date}` : ""
                      }
                      onClick={onclick}
                      endAdornment={
                        <InputAdornment
                          position="end"
                          sx={{ cursor: "pointer" }}
                        >
                          <EventIcon />
                        </InputAdornment>
                      }
                      disabled
                    />
                  </FormControl>
                </Box>
              ) : null}

              <Dialog
                open={open}
                onClose={onClose}
                children={
                  <DatePickerModal
                    onClose={onClose}
                    onDatePickerSub={onDatePickerSub}
                    from_date={from_date}
                    to_date={to_date}
                    handleReset={handleReset}
                    handleChange={onChange}
                    onClickDay={(item) => {}}
                  />
                }
                title="Select a date range"
              />
            </Stack>
          </Stack>

          <CheckInTable
            filteredData={checinCustome}
            toggleDrawer={toggleDrawer}
            drawerOpen={drawerOpen}
            dropdownData={dropdownData}
            handlecheckinsubmit={handlecheckinsubmit}
            isLoading={isLoading}
            page={page}
            limit={limit}
            totalItems={totalItems}
            onPageChange={onPageChange}
            checkInDetailsStatus={checkInDetailsStatus}
          />
        </Paper>
      </Grid>
    </Grid>
  );
};

const filteroldest = [{label:"All",value:"All"},{label:"checked in with invoice number",value:"checkedInWithInvoiceNumber"}, {label:"self checked in",value:"selfCheckedIn"}];

const useStyles = makeStyles((theme) => ({
  table: {
    "@media (max-width:768px)": {
      marginTop: "99%",
    },
  },

  table_location: {
    "@media (max-width:768px)": {
      width: "235%",
    },
  },

  table_date: {
    "@media (max-width:768px)": {
      width: "218%",
    },
  },
  searchBox: {
    float: "right",
    textAlign: "right",
    alignContent: "flex-end",
    borderRadius: "5px !important",
    "@media (max-width:768px)": {
      float: "none",
      marginTop: "-38px",
      marginBottom: "20px",
    },
  },
  exportfile: {
    marginTop: "-65px",
    background: "#19AA69",
    cursor: "pointer",
    height: "25px",
    width: "120px",
    float: "right",
    borderRadius: "30px",
    color: "white",
    display: "flex",
    padding: "5px 15px",
  },
  checkIn_heading_paper: {
    padding: "20px  3rem",
    marginTop: "1.5rem",
    marginLeft: "5px",
    // width: "73vw"
  },
  checkIn_text: {
    fontSize: "22px",
    marginBottom: "40px",
    color: "#707070",
  },
  fileDownload_icon: {
    fontSize: "20px",
    marginTop: "3px",
  },
  searchBox_paper: {
    padding: "2.5px 0",
    display: "flex",
    alignItems: "center",
    marginTop: "50px",
    marginBottom: "20px",
    width: "200px",
    height: "32px",
  },
  filter_checkIn_container: {
    justifyContent: "space-between",
    marginBottom: "20px",
    height: "3.5rem",
  },
}));
export default CheckIn;
